<template>

    <ul class="p-0 mt-2">
        <li v-for="(file, index) in Files" :key="index" class="d-flex justify-content-between">
            <div v-if="!file.timestamp && !file.path">
                <a href="#" @click.prevent="downloadApplication(file , true)">{{file.path ? file.path.split('/').pop() : ''}} </a>|
                <a href="#" @click.prevent="downloadApplication(file)"> <i class="fa fa-search" aria-hidden="true"></i></a>
            </div>
            <div v-else>
                {{file.timestamp}} <span v-if="file.timestamp && file.path">|</span>
                
                <a href="#" @click.prevent="downloadApplication(file.path , true)">{{file.path ? file.path.split('/').pop() : ''}}</a>|
                <a href="#" @click.prevent="downloadApplication(file.path)"> <i class="fa fa-search" aria-hidden="true"></i></a>
            </div>
            <div v-if="!readonly">
                <a href="#" v-if="!file.timestamp && !file.path" @click.prevent="removeApplicationFile(index, file, Item)" class="text-danger" :title="$t('form.student.remove')">X</a>
                <a href="#" v-else @click.prevent="removeApplicationFile(index, file.path, Item)" class="text-danger" :title="$t('form.student.remove')">X</a>
            </div>             
        </li>
    </ul>
</template>

<script>

export default {
name:'DownloadAndView',
 props: {Files:Array, downloadZipApplication:Function, removeApplicationFile:Function, downloadApplication:Function, readonly:Boolean, Item:String}
}

</script>